import { ScoopText, ScoopButton, ScoopColumn } from '../../../../ui'
import styles from './DemoModeIndicator.module.scss'

export const DemoModeIndicator = ({ isPublic, promptsRemaining }) => {
    if (!isPublic) return null

    const isWarning = promptsRemaining <= 3

    return (
        <ScoopColumn className={`${styles.container} ${isWarning ? styles.warning : ''}`}>
            <ScoopText className={`${styles.title} ${isWarning ? styles.warning : ''}`}>
                Demo mode
            </ScoopText>
            <ScoopText className={`${styles.promptsText} ${isWarning ? styles.warning : ''}`}>
                {promptsRemaining === 0 ? 'Limit reached!' : `${promptsRemaining}/20 prompts left`}
            </ScoopText>
            {isWarning && (
                <ScoopButton
                    size="xs"
                    onClick={() => {
                        window.open('/signup', '_blank')
                    }}
                    className={styles.button}
                >
                    Get unlimited
                </ScoopButton>
            )}
        </ScoopColumn>
    )
}
